<template lang="html">
  <div class="upload">
    <ul class="img-list clear-float">
      <li v-for="(img,index) in imgList">
        <div class="img-item-wapper">
          <div class="loading" v-if="img.isLoading && inlineLoading">
            <i class="iconfont icon-loading"></i>
          </div>
          <div :style="`background-image:url(${img.url})`" class="img-item"  v-if="inlineLoading ? !img.isLoading:true"></div>
          <sub @click="deleteImg(index)" v-if="inlineLoading ? !img.isLoading:true" class="iconfont icon-delete"></sub>
        </div>
      </li>
      <li class="upload-button" v-if="imgList.length !== this.limit">
        <div class="img-item-wapper">
          <div  @click="showXYUploadOption" class="XYUploadBtn" v-if="isNeedle"></div>
          <div v-else class="input-wapper">
            <input type="file" accept="image/*" @change="handleChange"  ref="$input" multiple v-if="multiple">
            <input type="file" accept="image/*" @change="handleChange"  ref="$input" v-else>
          </div>
          <i class="iconfont icon-plus"></i>
        </div>
      </li>
    </ul>
    <transition name="fade-in">
      <div class="xy-upload-toast" v-show = "this.XYUploadOption">
        <div class="mask" @click="closeXyUpload"></div>
        <div class="upload-option-container">
          <ul>
            <li @click="XYUploadHandle('camera')">
              <span>拍照</span>
              <i class="iconfont icon-camera"></i>
            </li>
            <li @click="XYUploadHandle('album')">
              <span>
                照片
              </span>
              <i class="iconfont icon-photo"></i>
            </li>
          </ul>
          <div class="cancel" @click="closeXyUpload">
            取消
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script >
import userAgent from './lib/userAgent';
import ajax from './lib/ajax';
import './style/reset.scss';
import './assets/iconfont/iconfont.css';
export default {
  name: 'upload-sdk',
  data() {
    return {
      imgList: [],
      XYUploadOption: false,
      isNeedle: false
    };
  },
  props: {
    action: {
      type: String,
      required: true
    },
    withCredentials: Boolean,
    headers: Object,
    limit: Number, // 上传数量限制
    onExceed: Function, // 超出数量限制的回调
    sizeLimit: Number, // 文件大小限制
    onExceedSize: Function, // 文件大小超过限制回调
    onSuccess: Function,
    onError: Function, // 错误回调
    srcList: Array, // 双向绑定上传后的array
    multiple: {
      type: Boolean,
      default: false
    },
    needle: Object,
    beforeUpload: Function,
    onAlllSuccess: Function,
    inlineLoading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteImg(index) {
      this.imgList.splice(index, 1);
    },
    handleChange(e) {
      const files = e.target.files;
      if (files.length !== 0) {
        for (let i = 0;i < files.length; i++) {
          if (!this.validate(files[i], files)) return;
          this.uploadFile(files[i], files);
        }
      }
      this.$refs.$input.value = '';
    },
    XYUploadHandle(type) {
      this.XYUploadOption = false;
      this.needle.image.pick({ type: type }, (error, { base64 }) => {
        if (error) {
          if (this.onError) {
            this.onError(error);
          } else {
            throw new Error(error.message);
          }
        } else {
          let file = this.base64ToFile(base64);
          if (!this.validate(file, [file])) return;
          this.uploadFile(file, [file]);
        }
      });
    },
    uploadFile(file, filesList) {
      let copyFileList = [...filesList];
      if (this.beforeUpload) {
        this.beforeUpload(file, copyFileList);
      }
      let imageData = new FormData();
      imageData.append('file', file);
      let fileInfo = {
        'name': file.name ? file.name : `${Date.now()}.png`,
        'url': window.URL.createObjectURL(file),
        'isLoading': true
      };
      this.imgList.push(fileInfo);
      let lastIndex = this.imgList.length - 1;
      let options = {
        action: this.action,
        withCredentials: this.withCredentials,
        headers: this.headers,
        data: imageData
      };
      ajax(options).then((data)=>{
        this.imgList.splice(lastIndex, 1, {
          ...fileInfo,
          response: data
        });
        this.imgList[lastIndex] = Object.assign(this.imgList[lastIndex], {'isLoading': false});
        if (this.onSuccess) {
          this.onSuccess(data, file, copyFileList);
        }
      }, (statusText)=>{
        if (this.onError) {
          this.onError(statusText, file, copyFileList);
        }
      });
    },
    validate(files, filesList) {
      // 如果没有
      if (!files) return false;
      // 验证个数
      if (this.limit && filesList.length + this.imgList.length > this.limit) {
        if (this.onExceed) {
          this.onExceed(files, filesList);
        } else {
          throw new Error('文件超过个数');
        }
        return false;
      }
      // 验证大小
      if (this.sizeLimit && files.size / 1024 / 1024 > this.sizeLimit) {
        if (this.onExceedSize) {
          this.onExceedSize(files, filesList);
        } else {
          throw new Error('文件超出大小限制');
        }
        return false;
      }
      return true;
    },
    showXYUploadOption() {
      this.XYUploadOption = true;
    },
    closeXyUpload() {
      this.XYUploadOption = false;
    },
    base64ToFile(urlData) {
      try {
        // 转换为byte
        let bytes = window.atob(urlData);
        let bufferData = new window['ArrayBuffer'](bytes.length);
        let UintData = new window['Uint8Array'](bufferData);
        for (let i = 0; i < bytes.length; i++) {
          UintData[i] = bytes.charCodeAt(i);
        }
        let blobData = new Blob([UintData], {type: 'image/png'});
        return blobData;
      } catch (e) {
        alert('blob error');
      }
    },
    compareVersion(v1, v2) {
    	var _v1 = v1.split('.'),
  		    _v2 = v2.split('.'),
    		  _r = _v1[0] - _v2[0];
      return _r == 0 && v1 != v2 ? compareVersion(_v1.splice(1).join('.'), _v2.splice(1).join('.')) : _r;
    }
  },
  mounted() {
    // needle低于‘0.2.5并且是安卓使用SDK’
    if ((userAgent.isXY() || userAgent.isNapos()) && this.needle && userAgent.isAndroid()) {
      this.needle.app.getEnvInfo(function(err, res) {
        if (err) {
          if (this.onError) {
            this.onError(err);
          } else {
            throw new Error('needle error');
          }
        } else {
          // 比较版本号
          if (this.compareVersion('0.2.5', res.sdkVersion) > 0) {
            this.isNeedle = true;
          }
        }
      });
    }
  },
  watch: {
    imgList(newValue) {
      this.$emit('update:srcList', newValue);
    },
    srcList: {
      handler(val) {
        if (!val) {
          return;
        }
        this.imgList = val || [];
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
  .upload{
    width: 100%;
    .img-list{
      width: 100%;
      li{
        width: 23.5%;
        margin-right: 2%;
        margin-bottom: 0.3rem;
        height: 0;
        float: left;
        position: relative;
        padding:11.75% 0;
        .img-item-wapper{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
        sub{
          position: absolute;
          right: -10px;
          top: -10px;
          background: #fa5555;
          width: 20px;
          line-height: 20px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          border-radius: 50%;
          z-index: 9997;
        }
        .img-item{
          width: 100%;
          height: 100%;
          background-size: cover;
        }
        img{
          width: 100%;
          height: 100%;
        }
        @keyframes rotation{
          from {transform: rotate(0deg);}
          to {transform: rotate(360deg);}
        }
        .loading{
          width: 100%;
          height: 100%;
          i{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            animation: rotation 1s linear infinite;
            color: #ccc;
            font-size: 36px;
          }
          i:before{
            display: inline-block;
            vertical-align: sub;
          }
        }
      }
      li:nth-of-type(4n){
        margin: 0;
      }
      .upload-button{
        position: relative;
        border: dashed 1px #d8dce5;
        background: #f7f9fc;
        .input-wapper,.XYUploadBtn{
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          visibility: 0;
          top: 0;
          left: 0;
          opacity: 0;
          z-index: 999;
        }
        input{
          display: block;
          width: 100%;
          height: 100%;
        }
        i{
          display:  inline-block;
          width: 100%;
          font-size: 38px;
          text-align: center;
          color: #d8dce5;
          height: 100%;
        }
        i:before{
          vertical-align: text-bottom;
          display: inline-block;
          width: 100%;
          position: relative;
          top: 18px;
        }
      }
    }
  }
  .xy-upload-toast{
    width: 100%;
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(148, 148, 148, .6);
      z-index: 9998;
    }
    .upload-option-container{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 9999;
      padding: 0 1.5%;
      ul{
        background: #fff;
        border-radius: 8px;
        margin-bottom: 20px;
        li{
          line-height: 120px;
          padding: 0 24px;
          border-bottom:1px solid rgb(240,240,240);
          span{
            font-size: 36px;
          }
          i{
            display: inline-block;
            width: 18px;
            height: 18px;
            float: right;
            color:#26a2ff;
            font-size: 38px;
            margin-right: 24px;
          }
        }
        li:last-of-type{
          border: 0;
        }
      }
      .cancel{
        font-size: 36px;
        line-height: 120px;
        padding: 0 24px;
        background: #fff;
        border-radius: 8px;
        text-align: center;
        color:#26a2ff;
        margin-bottom: 24px;
      }
    }
  }
  .fade-in-enter-active,
  .fade-in-leave-active {
    transition: all .5s cubic-bezier(.55, 0, .1, 1);
  }
  .fade-in-enter,
  .fade-in-leave-active {
    opacity: 0;
  }
  .clear-float:after{
    clear: both;
    content: '';
    height: 0;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/upload.vue